import React from 'react';
import {Card, Modal, Spinner, Tooltip, OverlayTrigger} from 'react-bootstrap'
import { useNavigate } from "react-router-dom";
import { AiOutlineRead } from "react-icons/ai";
import { BsPlayBtnFill } from "react-icons/bs";
import '../css sheets/portfolio.css'



function Portfolio(){


    function GrowLive() {
    return <OverlayTrigger  placement="right" overlay={<Tooltip>Application Live</Tooltip>}><Spinner  animation="grow" variant='success'
    style={{
        animationDuration: '1.5s', // Adjust the duration to change the speed
        animationTimingFunction: 'linear', // Adjust the timing function 
      }}/></OverlayTrigger>;
    }

    function GrowDown() {
        return <OverlayTrigger  placement="right" overlay={<Tooltip>Application Down</Tooltip>}><Spinner animation="grow" variant='danger'
        style={{
            animationDuration: '1.5s', // Adjust the duration to change the speed
            animationTimingFunction: 'linear', // Adjust the timing function 
          }}/></OverlayTrigger>;
        }

        function Read_Travel_Blog() {
            const [lgShow, setLgShow] = React.useState(false);
            return (
            <>
                <AiOutlineRead onClick={() => setLgShow(true)} className='read_about_icon'/>
                <Modal
                size="md"
                width="50%"
                show={lgShow}
                onHide={() => setLgShow(false)}
                aria-labelledby="example-modal-sizes-title-lg"
                dialogClassName="custom-modal-dialog"
                >
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-lg">
                    ABOUT TRAVEL BLOG
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className='portfolio_modal_body'>
                    This project is a simple single page React application which I began work on as a way to learn the 
                    Vite build tool for web applications. I wasn't exactly sure what I would create at first, but I knew that 
                    I wanted to incorporate some of my photos this time. Once I began digging through my gallery I became inspired 
                    to create a travel blog, something my family has long suggested that I do. I was very happy to be able to demonstrate 
                    my skills as a developer while also sharing about one of my passions. You can see my project 
                    for yourself <a href="https://andrew-thomas-travels.onrender.com" target="blank">here</a>.
                </Modal.Body>
                </Modal>
            </>
            );
        }

    function Read_TaskApp() {
        const [lgShow, setLgShow] = React.useState(false);
        return (
        <>
            <AiOutlineRead onClick={() => setLgShow(true)} className='read_about_icon'/>
            <Modal
            size="md"
            width="50%"
            show={lgShow}
            onHide={() => setLgShow(false)}
            aria-labelledby="example-modal-sizes-title-lg"
            dialogClassName="custom-modal-dialog"
            >
            <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                ABOUT TASK APP PROJECT
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='portfolio_modal_body'>
                This project is a simple MERN application that allows users to make their own to-do list that is saved to MongoDB. At present, 
                users can add and remove individual to-do list items, edit existing items, and also simply cross them out without removing them 
                from their list. Furthermore, users are able to create an account using their Google account. You can try the application out 
                for yourself <a href="https://taskapp-ht0c.onrender.com/#/" target="blank">here</a>.
            </Modal.Body>
            </Modal>
        </>
        );
    }

    function Read_Mojave_Tech() {
        const [lgShow, setLgShow] = React.useState(false);
        return (
        <>
            <AiOutlineRead onClick={() => setLgShow(true)} className='read_about_icon'/>
            <Modal
            size="md"
            width="50%"
            show={lgShow}
            onHide={() => setLgShow(false)}
            aria-labelledby="example-modal-sizes-title-lg"
            dialogClassName="custom-modal-dialog"
            >
            <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                ABOUT MOJAVE TECH SOLUTIONS
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='portfolio_modal_body'>
                I created this project using Vite and ReactJS. It is the frontend for the website of a fictitious company, "Mojave Technical Solutions".
                The purpose of this project was to demonstrate my skills using React and CSS.
                 <a href="https://mojave-technical-solutions.onrender.com/#content-1" target="blank">here</a>.
            </Modal.Body>
            </Modal>
        </>
        );
    }

    function Watch_TaskApp() {
        const [lgShow, setLgShow] = React.useState(false);
        return (
        <>
            <BsPlayBtnFill onClick={() => setLgShow(true)} className='read_about_icon'/>
            <Modal
            size="xl"
            show={lgShow}
            onHide={() => setLgShow(false)}
            aria-labelledby="example-modal-sizes-title-lg"
            className="project-watch-modal"
            >
            <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                WATCH TASK APP DEMO
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <iframe className="project-iframe" width="1100" height="650" src="https://www.youtube.com/embed/Q3Ex-rnJU-M?si=4w93NW9FonieuQqy" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            </Modal.Body>
            </Modal>
        </>
        );
    }

    function Read_Market_DB() {
        const [lgShow, setLgShow] = React.useState(false);
        return (
        <>
            <AiOutlineRead onClick={() => setLgShow(true)} className='read_about_icon'/>
            <Modal
            
            size="md"
            width="50%"
            show={lgShow}
            onHide={() => setLgShow(false)}
            aria-labelledby="example-modal-sizes-title-lg"
            dialogClassName="custom-modal-dialog"
            >
            <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                ABOUT MARKET DB PROJECT
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='portfolio_modal_body'>
                This project is a simple MERN stack application that I created to streamline a process at my workplace. Every month students can buy prizes using their "academy dollars" during a "market day", however they're only allowed to buy two items per month. 
                So, it's necessary for teachers to keep track of student purchases. The current system is that a staff member prints out sheets of paper with "stamp cards", and then stamps the back of each to authenticate them. These 
                sheets are then distributed to teachers who have to cut them out and distribute them to students, and then update a large Google sheet to confirm that each students has been given their stamp card. This process is to be repeated each month. 
                My MERN stack project allows teachers responsible for the market to quickly search students by name from a Mongo database and confirm their monthly purchases digitally when they buy items. The service can be comfortably
                used both via smartphone or computer screen. If implemented, this service eliminates the need for teachers to cut out stamp cards by hand, distribute them to students, and update the Google sheet confirming they've received their stamp card. 
                Additionally it saves staff members the time to print out sheets of stamp cards and then stamp the back of each. Lastly, it would save the academy a considerable amount of paper. <a href="https://market-db.onrender.com/#/" target="blank">here</a>.
            </Modal.Body>
            </Modal>
        </>
        );
    }

    function Watch_MarketDB() {
        const [lgShow, setLgShow] = React.useState(false);
        return (
        <>
            <BsPlayBtnFill onClick={() => setLgShow(true)} className='read_about_icon'/>
            <Modal
            size="xl"
            show={lgShow}
            onHide={() => setLgShow(false)}
            aria-labelledby="example-modal-sizes-title-lg"
            className="project-watch-modal"
            >
            <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                WATCH MARKET DB DEMO
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <iframe className="project-iframe" width="1100" height="650" src="https://www.youtube.com/embed/4ZsC0aUV5vc?si=kkAZREKktI0Fr5ff" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            </Modal.Body>
            </Modal>
        </>
        );
    }



    function Read_Student_Bank() {
        const [lgShow, setLgShow] = React.useState(false);
        return (
        <>
            <AiOutlineRead onClick={() => setLgShow(true)} className='read_about_icon'/>
            <Modal
            size="md"
            width="50%"
            show={lgShow}
            onHide={() => setLgShow(false)}
            aria-labelledby="example-modal-sizes-title-lg"
            dialogClassName="custom-modal-dialog"
            >
            <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                ABOUT STUDENT BANK PROJECT
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='portfolio_modal_body'>
                At my current workplace we give students "money" for good behavior and academic achievement, once a month the students can then spend that money on toys and class 
                materials etc. This system however, leads to many issues. Dollars have to be printed, cut, laminated and stamped by desk staff, then teachers have to keep a supply
                available for distribution. I find that I am chronically short on ones and frequenlty have to issue IOUs. Additionally, dollars are frequently misplaced by students. Furthermore, every month fliers have do be 
                printed and displayed in all classrooms to show available prizes which students then have to queue up to view. This application allows students to create an account and then receive their dollars digitally
                from teachers and also browse and place orders for prizes online which then is automatically deducted from their balance. Recently I met my boss to present the project, the idea was well received but the 
                decision to implement my system is still pending.
            </Modal.Body>
            </Modal>
        </>
        );
    }

    function Watch_Student_Bank() {
        const [lgShow, setLgShow] = React.useState(false);
        return (
        <>
            <BsPlayBtnFill onClick={() => setLgShow(true)} className='read_about_icon'/>
            <Modal
            size="xl"
            show={lgShow}
            onHide={() => setLgShow(false)}
            aria-labelledby="example-modal-sizes-title-lg"
            className="project-watch-modal"
            >
            <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                WATCH STUDENT BANK DEMO
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <iframe className="project-iframe" width="1100" height="650" src="https://www.youtube.com/embed/mwdfwvQvT2k" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay;  fullscreen; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </Modal.Body>
            </Modal>
        </>
        );
    }

    function Read_Commentas() {
        const [lgShow, setLgShow] = React.useState(false);
        return (
        <>
            <AiOutlineRead onClick={() => setLgShow(true)} className='read_about_icon'/>
            <Modal
            size="md"
            show={lgShow}
            onHide={() => setLgShow(false)}
            aria-labelledby="example-modal-sizes-title-lg"
            dialogClassName="custom-modal-dialog"
            >
            <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                ABOUT COMMENTS PROJECT
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='portfolio_modal_body'>
                This project was my first Solo MERN application which I built after completing my MITxpro course. I work as a teacher in Korea so naturally I have to write up a large number of comments giving student feedback on a regular basis. There are many existing websites that help with this 
                but so far the only ones I had seen were static and used preset comments written by the site creators. I am not one to arbitrarily give feedback to students, I find that quite unethical. I want some helpful automation however, the words should be accurate and my own. So, I decided to tackle this issue according to my requirements, I built a site where the user can create their own account, and then write and save their own repertoire of comments which they can then
                apply with the click of a button along with name and gender pronoun replacement. To view this project you can follow the link   
                <a href="https://commentas.herokuapp.com/" target="blank"> here</a>.
            </Modal.Body>
            </Modal>
        </>
        );
    }

    function Watch_Commentas() {
        const [lgShow, setLgShow] = React.useState(false);
        return (
        <>
            <BsPlayBtnFill onClick={() => setLgShow(true)} className='read_about_icon'/>
            <Modal
            size="xl"
            show={lgShow}
            onHide={() => setLgShow(false)}
            aria-labelledby="example-modal-sizes-title-lg"
            className="project-watch-modal"
            >
            <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                WATCH COMMENT GENERATOR DEMO
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <iframe className="project-iframe" width="1100" height="650"  src="https://www.youtube.com/embed/UdUQNFU1T5A" title="YouTube video player" frameborder="0" allow="accelerometer; fullscreen; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </Modal.Body>
            </Modal>
        </>
        );
    }

    function Read_First_Site() {
        const [lgShow, setLgShow] = React.useState(false);
        return (
        <>
            <AiOutlineRead onClick={() => setLgShow(true)} className='read_about_icon'/>
            <Modal
            size="md"
            show={lgShow}
            onHide={() => setLgShow(false)}
            aria-labelledby="example-modal-sizes-title-lg"
            dialogClassName="custom-modal-dialog"
            >
            <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                ABOUT FIRST WEBSITE
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='portfolio_modal_body'>
            This project was assigned as the First big Project for my MITxPro Full Stack developer with MERN course about 12 weeks into the program. 
            The requirements were rather simple, create a website using HTML, CSS, and JS. The website was meant to introduce myself and three smaller coding projects I had completed thus far in the course. 
            I received top marks for the project and was pretty happy with my work at that time. Of course my skills have progressed a lot since then so I've included it here as a benchmark of my progression. 
            You can click the link <a href="https://drewsclues.github.io/" target="blank">here</a>.
            
            </Modal.Body>
            </Modal>
        </>
        );
    }

    function Watch_First_Site() {
        const [lgShow, setLgShow] = React.useState(false);
        return (
        <>
            <BsPlayBtnFill onClick={() => setLgShow(true)} className='read_about_icon'/>
            <Modal
            size="xl"
            show={lgShow}
            onHide={() => setLgShow(false)}
            aria-labelledby="example-modal-sizes-title-lg"
            className="project-watch-modal"
            >
            <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                WATCH FIRST WEBSITE DEMO
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <iframe className="project-iframe" width="1100" height="650" src="https://www.youtube.com/embed/JiFqih4nhXk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay;  fullscreen; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </Modal.Body>
            </Modal>
        </>
        );
    }

    function Read_CAPSTONE() {
        const [lgShow, setLgShow] = React.useState(false);
        return (
        <>
            <AiOutlineRead onClick={() => setLgShow(true)} className='read_about_icon'/>
            <Modal
            size="md"
            show={lgShow}
            onHide={() => setLgShow(false)}
            aria-labelledby="example-modal-sizes-title-lg"
            dialogClassName="custom-modal-dialog"
            >
            <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                ABOUT MITxpro CAPSTONE PROJECT
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='portfolio_modal_body'>
            This project was assigned as the Final Project for my MITxPro Full Stack developer with MERN course. 
            The instructions were to create a simple full stack banking application that allowed a user to create an account, 
            both deposit and withdraw money from that account (update the balance). Display the user's name or email on the top right corner of the screen
            when they are logged and most importantly user data needed to persist between sessions. We were encouraged to add some additional features
            to the application, in my case I created a function that allows users to transfer money to other known accounts. I used Mongo Atlas DB for the database, Express server, Reactjs for the frontend
            and hosted the application on Heroku. You can link to the project <a href="https://andrewthomasfsbankapplication.herokuapp.com/" target="blank">here</a>. 
        </Modal.Body>
            </Modal>
        </>
        );
    }

    function Watch_Capstone() {
        const [lgShow, setLgShow] = React.useState(false);
        return (
        <>
            <BsPlayBtnFill onClick={() => setLgShow(true)} className='read_about_icon'/>
            <Modal
            size="xl"
            show={lgShow}
            onHide={() => setLgShow(false)}
            aria-labelledby="example-modal-sizes-title-lg"
            className="project-watch-modal"
            >
            <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                WATCH CAPSTONE DEMO
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <iframe className="project-iframe" width="1100" height="650" src="https://www.youtube.com/embed/4vaor5c5PxY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay;  fullscreen; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </Modal.Body>
            </Modal>
        </>
        );
    }
    
    return(
        <div>
            <div className='custom-portfolio-div'>
                <span className='header-span'>My Projects</span>

                <div className='portfolio_grid'>


                <Card className="custom-portfolio-card">
                        <Card.Body>
                            <h1>Mojave Tech Solutions <GrowLive/></h1>
                        <div className="portfolio-content">
                        <a href="https://mojave-technical-solutions.onrender.com/#content-1" target="blank">
                        <img src="Plain-Mojave3.png" className='active_portfolio-image' ></img>
                        </a>
                            <Card.Text className='portfolio-card-text'>
                                <div className='about-div'>
                                <h3 className="portfolio_card_title">About This Project</h3>
                                <Read_Mojave_Tech/> &#160; &#160;
                                </div>

                            </Card.Text>
                        </div>
                        </Card.Body>
                    </Card>




                <Card className="custom-portfolio-card">
                        <Card.Body>
                            <h1>Travel Blog <GrowLive/></h1>
                        <div className="portfolio-content">
                        <a href="https://andrew-thomas-travels.onrender.com" target="blank">
                        <img src="Travel_icon_dark.png" className='active_portfolio-image' ></img>
                        </a>
                            <Card.Text className='portfolio-card-text'>
                                <div className='about-div'>
                                <h3 className="portfolio_card_title">About This Project</h3>
                                <Read_Travel_Blog/> &#160; &#160;
                                </div>

                            </Card.Text>
                        </div>
                        </Card.Body>
                    </Card>

                    <Card className="custom-portfolio-card">
                        <Card.Body>
                            <h1>Task App <GrowLive/></h1>
                        <div className="portfolio-content">
                        <a href="https://taskapp-ht0c.onrender.com/#/" target="blank">
                        <img src="task_logo.png" className='active_portfolio-image' ></img>
                        </a>
                            <Card.Text className='portfolio-card-text'>
                                <div className='about-div'>
                                <h3 className="portfolio_card_title">About This Project</h3>
                                <Read_TaskApp/> &#160; &#160;
                                <Watch_TaskApp/>
                                </div>

                            </Card.Text>
                        </div>
                        </Card.Body>
                    </Card>

                    <Card className="custom-portfolio-card">
                        <Card.Body>
                            <h1>Market DB <GrowLive/></h1>
                        <div className="portfolio-content">
                        <a href="https://market-db.onrender.com/#/" target="blank">
                            <img src="MKDB_logo.png" className='active_portfolio-image' ></img>
                        </a>
                            <Card.Text className='portfolio-card-text'>
                                <div className='about-div'>
                                <h3 className="portfolio_card_title">About This Project</h3>
                                <Read_Market_DB/> &#160; &#160;
                                <Watch_MarketDB/>
                                </div>

                            </Card.Text>
                        </div>
                        </Card.Body>
                    </Card>

                    <Card className="custom-portfolio-card">
                        <Card.Body>
                            <h1>Student Bank <GrowDown/></h1>
                        <div className="portfolio-content">
                        <img src="M_bank_logo.png" className='portfolio-image' ></img>
                            <Card.Text className='portfolio-card-text'>
                                <div className='about-div'>
                                <h3 className="portfolio_card_title">About This Project</h3>
                                <Read_Student_Bank/> &#160; &#160;
                                <Watch_Student_Bank/>
                                </div>

                            </Card.Text>
                        </div>
                        </Card.Body>
                    </Card>


                    <Card className="custom-portfolio-card">
                        <Card.Body>
                            <h1>Comments App <GrowDown/></h1>
                        <div className="portfolio-content">
                        <img src="Cactus_logo.png" className='portfolio-image' ></img>
                            <Card.Text className='portfolio-card-text'>
                                <div className='about-div'>
                                <h3 className="portfolio_card_title">About This Project</h3>
                                <Read_Commentas/> &#160; &#160;
                                <Watch_Commentas/>
                                </div>

                            </Card.Text>
                        </div>
                        </Card.Body>
                    </Card>


                    <Card className="custom-portfolio-card">
                        <Card.Body>
                            <h1>Capstone Project <GrowDown/></h1>
                        <div className="portfolio-content">
                        <img src="bank.png" className='portfolio-image' ></img>
                            <Card.Text className='portfolio-card-text'>
                                <div className='about-div'>
                                <h3 className="portfolio_card_title">About This Project</h3>
                                <Read_CAPSTONE/> &#160; &#160;
                                <Watch_Capstone/>
                                </div>

                            </Card.Text>
                        </div>
                        </Card.Body>
                    </Card>


                    <Card className="custom-portfolio-card">
                        <Card.Body>
                            <h1>First Website <GrowLive/></h1>
                        <div className="portfolio-content">
                        <a href="https://drewsclues.github.io/" target="blank">
                            <img src="first_web.png" className='active_portfolio-image' ></img>
                        </a>
                            <Card.Text className='portfolio-card-text'>
                                <div className='about-div'>
                                <h3 className="portfolio_card_title">About This Project</h3>
                                <Read_First_Site/> &#160; &#160;
                                <Watch_First_Site/>
                                </div>

                            </Card.Text>
                        </div>
                        </Card.Body>
                    </Card>


                </div>
            </div>
        </div>
    )

}

export default Portfolio;